export const ERROR_MESSAGES = {
	NO_CREDIT_OFFER: 'No se obtuvo una oferta de credito para ti.',
	OFFER_EVALUATION_FAILED: 'No se pudo evaluar una oferta para ti',
	IDENTITY_NOT_VALIDATED:
		'No fue posible validar la identidad de la persona. Te invitamos a visitar una de nuestras sucursales para continuar con tu trámite.',
} as const;

export const REJECTION_CODES = {
	IDENTITY_NOT_VALIDATED: 'F701-IDENT',
} as const;
